import React from 'react';
import Icon from '../AppIcon';

/**
 * AccessDenied Component
 * Displays when a user doesn't have permission to view content
 *
 * @param {Object} props
 * @param {string} props.permission - The permission that was denied (for display)
 * @param {string} props.customMessage - Optional custom message to display
 * @param {boolean} props.showContactInfo - Whether to show contact info (default: true)
 * @param {string} props.variant - 'card' (default) or 'inline'
 */
const AccessDenied = ({
  permission,
  customMessage,
  showContactInfo = true,
  variant = 'card'
}) => {
  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-3 p-4 bg-red-500/10 border border-red-500/30 rounded-lg">
        <Icon name="Lock" size={20} color="#ef4444" />
        <p className="text-red-400 text-sm">
          {customMessage || `You don't have permission to ${permission}.`}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-xl p-8 text-center">
      <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Lock" size={32} color="#ef4444" />
      </div>

      <h3 className="text-xl font-semibold text-text-primary mb-2">
        Access Restricted
      </h3>

      <p className="text-text-secondary mb-4">
        {customMessage || `You don't have permission to ${permission}.`}
      </p>

      {showContactInfo && (
        <p className="text-text-tertiary text-sm">
          Contact your manager or administrator to request access.
        </p>
      )}
    </div>
  );
};

export default AccessDenied;
